import { render, staticRenderFns } from "./aRmsPvpEvolutionTooltip.vue?vue&type=template&id=2147bd20"
import script from "./aRmsPvpEvolutionTooltip.vue?vue&type=script&lang=js"
export * from "./aRmsPvpEvolutionTooltip.vue?vue&type=script&lang=js"
import style0 from "./aRmsPvpEvolutionTooltip.vue?vue&type=style&index=0&id=2147bd20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataTable,VIcon,VTooltip})
